import type { UseQueryResult } from '@tanstack/react-query'
import { useIsFetching, useQuery } from '@tanstack/react-query'

import type { BidType, MarketProgram } from '@/features/bidding/constants'
import { getBidExportsIntraday } from '@/features/bidding/endpoints/bids'
import { useErrorHandler } from '@/features/bidding/hooks/useErrorHandler'

export const GET_BID_EXPORTS_INTRADAY_API_ID = 'GET_BID_EXPORTS_INTRADAY'

export type UseBidExportsIntradayQueryParams = {
  portfolioCode: string
  marketProgram: MarketProgram
  deliveryDay: string
  bidType: BidType
}

export type UseBidExportsIntradayQueryResult = Omit<UseQueryResult, 'data'> & {
  bidExportsIntraday: string | null
}

export function useBidExportsIntradayQuery(params: UseBidExportsIntradayQueryParams): UseBidExportsIntradayQueryResult {
  const { data = null, ...queryResult } = useQuery({
    queryKey: [GET_BID_EXPORTS_INTRADAY_API_ID, params],
    queryFn: async () => {
      const response = await getBidExportsIntraday(
        params.portfolioCode,
        params.marketProgram,
        params.deliveryDay,
        params.bidType,
      )
      return response.data
    },
    enabled: false, // runs only on refetch
  })

  useErrorHandler(queryResult.isError)

  return { bidExportsIntraday: data, ...queryResult }
}

export function useIsFetchingBidExportsIntraday(): boolean {
  return useIsFetching({ queryKey: [GET_BID_EXPORTS_INTRADAY_API_ID] }) > 0
}
